/* AD-08 · FLAGS, JOBS & INCIDENTS
   ADM-19/20/22: per-feature and emergency controls; queue health with
   customer-impact framing; incident timeline + status communication.
   · Bible XV */
import { Button, ListRow, Switch } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD08Platform() {
  const rows = useAdmin().platform
  return (
    <section data-frame="AD-08" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Drapeaux, files &amp; incidents</h2>
      <div>
        {rows.map((r, i) => (
          <ListRow key={r.title || i}
            title={r.strong
              ? r.strong.map((s, n) => (
                  <span key={s}>{n > 0 && ' · '}<strong>{s}</strong></span>
                ))
              : r.title}
            meta={r.meta}
            end={
              r.toggle ? <Switch checked readOnly aria-label={`${r.title} — actif`} />
              : r.status ? <Mark cell={r.status} />
              : r.action ? <Button variant="ghost" size="sm">{r.action}</Button>
              : undefined
            } />
        ))}
      </div>
    </section>
  )
}
